import { render, staticRenderFns } from "./itemBankSetting.vue?vue&type=template&id=60223f6b&scoped=true"
import script from "./itemBankSetting.vue?vue&type=script&lang=js"
export * from "./itemBankSetting.vue?vue&type=script&lang=js"
import style0 from "./itemBankSetting.vue?vue&type=style&index=0&id=60223f6b&prod&lang=less"
import style1 from "./itemBankSetting.vue?vue&type=style&index=1&id=60223f6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60223f6b",
  null
  
)

export default component.exports